/*
创建者 魏强(2018.2.1)
banner
*/
<template>
<div class="banner-wrapper">
  <div class="wrapper">
    <Carousel
      v-model="value"
      :autoplay="setting.autoplay"
      :autoplay-speed="setting.autoplaySpeed"
      :dots="setting.dots"
      :radius-dot="setting.radiusDot"
      :trigger="setting.trigger"
      :arrow="setting.arrow"
      :height="height||480"
      >
      <CarouselItem v-for="(item, index) in data " :key="index">
        <router-link class="img-box" :to="item.to" target="_blank">
          <img class="img-item" :src="item.atturl"  />
        </router-link>
      </CarouselItem>
    </Carousel>
  </div>
</div>
</template>
<script>
  export default{
    props:["data","height",'width'],
    data () {
          return {
              value: 0,
              setting: {
                  autoplay: true,
                  autoplaySpeed: 2000,
                  dots: 'inside',
                  radiusDot: true,
                  trigger: 'hover',
                  arrow: 'never'
              }
          }
      },
    methods:{
    }
  }
</script>
<style lang="less" scoped>
.img-box,.img-item{
  height:100%;
  width:100%;
  display: block;
}

</style>



// WEBPACK FOOTER //
// banner.vue?1f4ab496